export const TIME_TO_PING = 60 * 1000
export const TIME_TO_RECONNECT = 59 * 60 * 1000

export const TIME_TO_PONG = 15 * 1000
